module.exports = __webpack_public_path__ + "media/fonts/SFProText-Bold-03a7a8a73486664fb945e1a5bd464e0d.woff";